<template>
  <div>
    <TopBar />
    <el-container>
      <el-aside width="200px">
        <SideBar />
      </el-aside>
      <el-container>
        <el-header style="height: auto; padding: 0;">
          <el-row :gutter="20" style="padding: 20px;">
            <!-- 数据总览 -->
            <el-col :span="15">
              <el-card shadow="hover" style="height: 100%; border-radius: 8px;">
                <div slot="header" class="clearfix">
                  <span>数据总览</span>
                </div>
                <el-row :gutter="20" style="padding: 10px 0;">
                  <el-col :span="8">
                    <el-card shadow="never" class="data-card">
                      <div slot="header" class="clearfix">
                        <span>PPT</span>
                      </div>
                      <div class="text item">1,902</div>
                    </el-card>
                  </el-col>
                  <el-col :span="8">
                    <el-card shadow="never" class="data-card">
                      <div slot="header" class="clearfix">
                        <span>文档</span>
                      </div>
                      <div class="text item">2,445</div>
                    </el-card>
                  </el-col>
                  <el-col :span="8">
                    <el-card shadow="never" class="data-card">
                      <div slot="header" class="clearfix">
                        <span>视频</span>
                      </div>
                      <div class="text item">3,056</div>
                    </el-card>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="padding: 10px 0;">
                  <el-col :span="8">
                    <el-card shadow="never" class="data-card" style="height: 100%;">
                      <div slot="header" class="clearfix">
                        <span>讨论</span>
                      </div>
                      <div class="text item">688</div>
                    </el-card>
                  </el-col>
                  <el-col :span="8">
                    <el-card shadow="never" class="data-card">
                      <div slot="header" class="clearfix">
                        <span>测验</span>
                      </div>
                      <div class="text item">34</div>
                    </el-card>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
            <!-- 雷达图 -->
            <el-col :span="8">
              <el-card shadow="hover" style="height: 470px; border-radius: 8px;">
                <div slot="header" class="clearfix">
                  <span>课程资源分布</span>
                </div>
                <div id="radar-chart" style="height: 370px;"></div>
              </el-card>
            </el-col>
          </el-row>
        </el-header>
        <el-main>
          <el-row :gutter="20" style="padding: 20px;">
            <!-- 折线图 -->
            <el-col :span="12">
              <el-card shadow="hover" style="border-radius: 8px;">
                <div slot="header" class="clearfix">
                  <span>课程资源数量</span>
                </div>
                <div id="line-chart" style="height: 300px;"></div>
              </el-card>
            </el-col>
            <!-- 圆环图 -->
            <el-col :span="12">
              <el-card shadow="hover" style="border-radius: 8px;">
                <div slot="header" class="clearfix">
                  <span>资源总数</span>
                </div>
                <div id="donut-chart" style="height: 300px;"></div>
              </el-card>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import SideBar from '../components/SideBar.vue';
import TopBar from '../components/TopBar.vue';
import * as echarts from 'echarts';

export default {
  name: 'HomePage',
  components: {
    SideBar,
    TopBar
  },
  mounted() {
    this.initRadarChart();
    this.initLineChart();
    this.initDonutChart();
  },
  methods: {
    initRadarChart() {
      const radarChart = echarts.init(document.getElementById('radar-chart'));

      const option = {
        tooltip: {
          trigger: 'axis'
        },
        radar: {
          indicator: [
            { name: '计算机组成原理', max: 5000 },
            { name: '接口技术', max: 5000 },
            { name: '计算机基础', max: 5000 },
            { name: '单片机', max: 5000 },
            { name: '自动控制原理', max: 5000 },
            { name: '数字逻辑', max: 5000 }
          ]
        },
        series: [
          {
            name: '课程资源分布',
            type: 'radar',
            data: [
              {
                value: [1902, 2445, 3056, 688, 34, 1902],
                name: 'PPT',
                itemStyle: { color: '#C1232B' }
              },
              {
                value: [2445, 3056, 688, 34, 1902, 2445],
                name: '文档',
                itemStyle: { color: '#B5C334' }
              },
              {
                value: [3056, 688, 34, 1902, 2445, 3056],
                name: '视频',
                itemStyle: { color: '#FCCE10' }
              },
              {
                value: [688, 34, 1902, 2445, 3056, 688],
                name: '讨论',
                itemStyle: { color: '#E87C25' }
              },
              {
                value: [34, 1902, 2445, 3056, 688, 34],
                name: '测验',
                itemStyle: { color: '#27727B' }
              }
            ]
          }
        ]
      };

      radarChart.setOption(option);
    },
    initLineChart() {
      const lineChart = echarts.init(document.getElementById('line-chart'));

      const option = {
        title: {
          text: '课程资源数量'
        },
        tooltip: {},
        xAxis: {
          data: ['计算机组成原理', '接口技术', '计算机基础', '单片机', '自动控制原理', '数字逻辑']
        },
        yAxis: {},
        series: [
          {
            name: 'PPT',
            type: 'line',
            data: [1902, 2445, 3056, 688, 34, 1902]
          },
          {
            name: '文档',
            type: 'line',
            data: [2445, 3056, 688, 34, 1902, 2445]
          },
          {
            name: '视频',
            type: 'line',
            data: [3056, 688, 34, 1902, 2445, 3056]
          },
          {
            name: '讨论',
            type: 'line',
            data: [688, 34, 1902, 2445, 3056, 688]
          },
          {
            name: '测验',
            type: 'line',
            data: [34, 1902, 2445, 3056, 688, 34]
          }
        ]
      };

      lineChart.setOption(option);
    },
    initDonutChart() {
      const donutChart = echarts.init(document.getElementById('donut-chart'));

      const option = {
        color: ['#249eff', '#6F4DDC', '#249eff', '#21ccff', '#313ca9'], // 蓝色和紫色系配色
        tooltip: {
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '70%'],
            data: [
              { value: 1902, name: 'PPT' },
              { value: 2445, name: '文档' },
              { value: 3056, name: '视频' },
              { value: 688, name: '讨论' },
              { value: 34, name: '测验' }
            ],
            label: {
              show: true,
              formatter: '{d}%'
            },
            labelLine: {
              show: true
            }
          }
        ]
      };

      donutChart.setOption(option);
    }
  }
};
</script>

<style scoped>
.data-card {
  text-align: center;
  padding: 20px;
  border-radius: 8px;
  background-color: #f5f7fa;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.item {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.el-card {
  border-radius: 8px;
  background-color: #fff;
}
</style>
